export * from './WheelchairAccessibleIcon'
